import { registerFr } from '../i18n/index.js';

registerFr({
  'Admin': 'Administration',
  'who may enter, who may call, what the record settled on, and the trail of every change':
    'qui peut entrer, qui peut appeler, ce que le dossier a arrêté, et la trace de chaque changement',
  'Operators': 'Opérateurs',
  'accounts on the allowlist': 'comptes sur la liste d’accès',
  'Registration': 'Inscription',
  'allowlist or open': 'liste d’accès ou ouverte',
  'Audit entries · 7d': 'Entrées d’audit · 7 j',
  'recorded mutations': 'modifications enregistrées',
  'Settings': 'Paramètres',
  'rows in app_settings': 'lignes dans app_settings',
  'Refs minted': 'Références émises',
  'the counters and their next number': 'les compteurs et leur prochain numéro',
  // 'counting…', 'not collected' live in AgentsPage / common.
  '{allowlist} on the allowlist · {admins} admin': '{allowlist} sur la liste d’accès · {admins} admin',
  'allowlist': 'liste d’accès',
  // 'the record did not answer' is PersonPage's; 'open' here is a context variant — the mode of the
  // door, feminine in French (inscription ouverte), not common's plain 'open'.
  'open\u2016registration': 'ouverte',
  'anyone who reaches the login may register': 'quiconque atteint la connexion peut s’inscrire',
  'only listed e-mail addresses may log in': 'seules les adresses listées peuvent se connecter',
  'no mutation recorded in 7 days': 'aucune modification enregistrée en 7 jours',
  '{total} recorded mutations, all time': '{total} modifications enregistrées, depuis le début',
  'no ref minted yet': 'aucune référence émise pour l’instant',
  '{kinds} counters · monotonic, never reused': '{kinds} compteurs · monotones, jamais réutilisés',
  'What will fill the rest': 'Ce qui remplira le reste',
  'settings and the audit trail': 'paramètres et trace d’audit',
  'The operator allowlist and the audit log already exist behind the auth and audit kits; this page counts them above and is where they will surface in full: the allowlist and its edits, the registration switch, the application settings with their history, the ref counters one by one, and the audit trail with its before/after diffs.':
    'La liste d’accès et le journal d’audit existent déjà derrière les kits d’authentification et d’audit ; cette page les compte ci-dessus et c’est ici qu’ils apparaîtront en entier : la liste d’accès et ses modifications, l’interrupteur d’inscription, les paramètres de l’application avec leur historique, les compteurs de références un à un, et la trace d’audit avec ses différences avant/après.',
}, 'AdminPage');